import { useCallback, useState } from "react";

/**
 * Δ gosterim modu — legacy `js/utils.js` `deltaBadge()` + `js/kpi.js`
 * `deltaModeTabs` (localStorage `vdd.kpi.deltaMode`) portu. Yeni anahtar:
 * `asakai.kpi.deltaMode` (bkz. hooks/useKpiPeriod.tsx ayni desen). Context
 * YOK (usePeriod/useKpiPeriod'un aksine) — sayfa kendi `useDeltaMode()`
 * cagrisini yapar ve degeri kendi alt bilesenlerine (DeltaModeToggle,
 * DeltaBadge) prop olarak GECER; boylece ayni sayfadaki toggle + rozetler
 * tek render agacinda SENKRON kalir (iki bagimsiz useState localStorage'i
 * yalniz MOUNT'ta okur, birbirini canli GUNCELLEMEZ).
 */
export type DeltaMode = "pct" | "value";

const STORAGE_KEY = "asakai.kpi.deltaMode";
const DEFAULT_MODE: DeltaMode = "pct";

function isDeltaMode(value: unknown): value is DeltaMode {
  return value === "pct" || value === "value";
}

function readStored(): DeltaMode {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return isDeltaMode(raw) ? raw : DEFAULT_MODE;
  } catch {
    return DEFAULT_MODE;
  }
}

function writeStored(value: DeltaMode): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // yut — tercih hatirlama sadece kolaylik, yoklugu islevi bozmaz.
  }
}

export interface UseDeltaModeResult {
  deltaMode: DeltaMode;
  setDeltaMode: (mode: DeltaMode) => void;
}

export function useDeltaMode(): UseDeltaModeResult {
  const [deltaMode, setState] = useState<DeltaMode>(() => readStored());
  const setDeltaMode = useCallback((mode: DeltaMode) => {
    setState(mode);
    writeStored(mode);
  }, []);
  return { deltaMode, setDeltaMode };
}
